"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var marginStyle = function marginStyle(props) {
  if (typeof props.margin === 'string') {
    var margin = props.theme.global.edgeSize[props.margin];
    return "\n        margin-top: ".concat(margin, ";\n        margin-bottom: ").concat(margin, ";\n        margin-left: ").concat(margin, ";\n        margin-right: ").concat(margin, ";\n      ");
  }

  if (props.margin.vertical) {
    return "\n        margin-top: ".concat(props.theme.global.edgeSize[props.margin.vertical], ";\n        margin-bottom: ").concat(props.theme.global.edgeSize[props.margin.vertical], ";\n      ");
  }

  if (props.margin.horizontal) {
    return "\n        margin-left: ".concat(props.theme.global.edgeSize[props.margin.horizontal], ";\n        margin-right: ").concat(props.theme.global.edgeSize[props.margin.horizontal], ";\n      ");
  }

  if (props.margin.top) {
    return "margin-top: ".concat(props.theme.global.edgeSize[props.margin.top], ";");
  }

  if (props.margin.bottom) {
    return "margin-bottom: ".concat(props.theme.global.edgeSize[props.margin.bottom], ";");
  }

  if (props.margin.left) {
    return "margin-left: ".concat(props.theme.global.edgeSize[props.margin.left], ";");
  }

  if (props.margin.right) {
    return "margin-right: ".concat(props.theme.global.edgeSize[props.margin.right], ";");
  }

  return '';
};

var sizeStyle = function sizeStyle(props) {
  var size = props.size || 'medium';
  var data = props.theme.text[size];

  if (data) {
    return (0, _styledComponents.css)(["font-size:", ";line-height:", ";"], data.size, data.height);
  }

  return (0, _styledComponents.css)(["font-size:", ";line-height:normal;"], size);
};

var textAlignStyle = (0, _styledComponents.css)(["text-align:", ";"], function (props) {
  return props.textAlign;
});
var truncateStyle = "\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n";
var weightStyle = (0, _styledComponents.css)(["font-weight:", ";"], function (props) {
  return props.weight;
});

var setColor = function setColor(props) {
  var propsColor = props.color;
  var color = props.theme.colorDefault;

  if (props.primary) {
    color = props.theme.colorPrimary;
  }

  if (props.secondary) {
    color = props.theme.colorSecondary;
  } // color (string) passed in component property


  if (propsColor) {
    color = propsColor;
  }

  return (0, _styledComponents.css)(["color:", ""], color);
}; // ${props => console.log(props.theme)}


var _default = _styledComponents["default"].span.withConfig({
  displayName: "Text",
  componentId: "sc-1w6tyrg-0"
})(["", ";", " ", " ", " ", " ", ""], function (props) {
  return setColor(props);
}, function (props) {
  return sizeStyle(props);
}, function (props) {
  return props.margin && marginStyle(props);
}, function (props) {
  return props.textAlign && textAlignStyle;
}, function (props) {
  return props.truncate && truncateStyle;
}, function (props) {
  return props.weight && weightStyle;
});

exports["default"] = _default;